
<template>
<div>
  <multiselect v-model="value" deselect-label="Can't remove this value"
  track-by="countryName" label="countryName"
  placeholder="Select one" :options="countryInventorylist" :searchable="false" :allow-empty="false"  @select="changeSelection($event)">
    <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.countryName }}</strong> is written in<strong>  {{ option.shipId }}</strong></template>
  </multiselect>

</div>
</template>

<script>
import Multiselect from "vue-multiselect";



export default {
  name: "SelectorCountry",
  props: ["countryInventorylist"],
  components: { Multiselect },
  data() {
    return {
      value: null,
  options: [

    ],
    };
  },
  methods: {
    changeSelection(event) {
 this.$emit("changedSelect", event);
    },
    limitText(count) {
      return `and ${count} other Countries`;
    },
  
    alertme: function() {},
    setSelection: function(newValue) {
      this.value = newValue;
    },
    returnSelection: function() {
      return this.value;
    }
  }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.css"></style>

